export default __webpack_public_path__ + "static/media/Criminal Thoughts podcast.3d3f34be.jpeg";